import { render, staticRenderFns } from "./SaleSuccessActions.vue?vue&type=template&id=73a2b81c&scoped=true"
import script from "./SaleSuccessActions.vue?vue&type=script&lang=js"
export * from "./SaleSuccessActions.vue?vue&type=script&lang=js"
import style0 from "./SaleSuccessActions.vue?vue&type=style&index=0&id=73a2b81c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2b81c",
  null
  
)

export default component.exports